export default __webpack_public_path__ + "52cb737b682eb9661ee1cb1ea59113ff.woff";